export default {
  label: "Contacto",
  phoneNumber: "Número de teléfono",
  note: "Nota",
  addContact: "Agregar contacto",
  contacts: "Contactos",
  deleteContactsNotPossible:
    "No es posible eliminar el contacto porque uno de los contactos está vinculado a un activo.",
  deleteContactErrorMessage: "No es posible eliminar el contacto porque el contacto está vinculado a un activo.",
  deleteContactMessage: "¿Realmente quieres eliminar el contacto?",
  deleteContact: "Eliminar contacto",
  addNewContact: "Agregar nuevo contacto",
  addAnotherContact: "Agregar otro contacto",
  contactMessage: "Selecciona o crea al menos uno y como máximo 3 contactos.",
  searchContacts: "Buscar contactos por nombre o teléfono",
  loadingContacts: "Cargando contactos…",
  noMatchingContacts: "No hay contactos coincidentes",
  loadContactsError: "No se pudieron cargar los contactos.",
  retryContacts: "Reintentar",
  loadMoreContacts: "Cargar más contactos",
};
